// @flow
import React, { Component } from 'react';
import i18n from 'app/common/lib/i18n';
import { Box, Icon, Touchable, Text } from 'gestalt';

const ANNOTATION_REP_HEIGHT = 80;

const StateEnum = {
  ACTIVE: 0,
  INACTIVE: 1,
  ACTIVEHOVER: 2,
  INACTIVEHOVER: 3,
};

type State = {
  isMouseOver: boolean,
  isSelected: boolean,
};

type Props = {
  backgroundColor:
    | 'watermelon'
    | 'orange'
    | 'green'
    | 'pine'
    | 'olive'
    | 'midnight'
    | 'navy'
    | 'blue'
    | 'purple'
    | 'orchid'
    | 'eggplant'
    | 'maroon',
  image: string,
  id: string,
  isBlacklist: boolean,
  name: string,
  onClick: Function,
};

class AnnotationRep extends Component<Props, State> {
  state = {
    isMouseOver: false,
    isSelected: false,
  };

  getSelectionState = (isSelected: boolean, isMouseOver: boolean, isBlacklist: boolean) => {
    let selectionState;
    if ((isBlacklist && isSelected) || (!isBlacklist && !isSelected)) {
      selectionState = StateEnum.ACTIVE;
    } else {
      selectionState = StateEnum.INACTIVE;
    }

    if (isMouseOver) {
      if (selectionState === StateEnum.ACTIVE) {
        selectionState = StateEnum.ACTIVEHOVER;
      } else {
        selectionState = StateEnum.INACTIVEHOVER;
      }
    }
    return selectionState;
  };

  getIcon = (selectionState: number) => {
    let icon = 'check-circle';
    let iconColor = 'white';
    let shouldShowIcon = true;
    if (selectionState === StateEnum.ACTIVE) {
      icon = 'check-circle';
      iconColor = 'white';
    } else if (selectionState === StateEnum.ACTIVEHOVER) {
      icon = 'clear';
      iconColor = 'darkGray';
    } else if (selectionState === StateEnum.INACTIVEHOVER) {
      icon = 'check-circle';
      iconColor = 'darkGray';
    } else {
      shouldShowIcon = false;
    }
    return [icon, iconColor, shouldShowIcon];
  };

  handleMouseEnter = () => {
    this.setState({ isMouseOver: true });
  };

  handleMouseLeave = () => {
    this.setState({ isMouseOver: false });
  };

  handleClick = () => {
    this.props.onClick(this.props.id);
    this.setState((prevState) => ({ isSelected: !prevState.isSelected, isMouseOver: false }));
  };

  render() {
    const { backgroundColor, name, isBlacklist } = this.props;
    const { isSelected, isMouseOver } = this.state;

    const selectionState = this.getSelectionState(isSelected, isMouseOver, isBlacklist);
    const [icon, iconColor, shouldShowIcon] = this.getIcon(selectionState);
    const boxColor = selectionState === StateEnum.ACTIVE ? backgroundColor : 'lightGray';

    return (
      <Box height={ANNOTATION_REP_HEIGHT} position="relative" shape="rounded" color={boxColor}>
        <Touchable
          shape="rounded"
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          onTouch={this.handleClick}
        >
          <Box height={ANNOTATION_REP_HEIGHT} display="flex" alignItems="center">
            {shouldShowIcon && (
              <Box right position="absolute" marginRight={4}>
                <Icon
                  accessibilityLabel={i18n._('selected')}
                  icon={icon}
                  color={iconColor}
                  size={24}
                />
              </Box>
            )}
            <Box marginLeft={4} marginRight={12} position="absolute">
              <Text
                align="left"
                bold
                color={selectionState === StateEnum.ACTIVE ? 'white' : 'darkGray'}
                size="xl"
              >
                {name}
              </Text>
            </Box>
          </Box>
        </Touchable>
      </Box>
    );
  }
}

export default AnnotationRep;
